var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIcIndicatorsWhite(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 30,
    height: 20,
    viewBox: "0 0 30 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "#FFFFFF",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M26.69 14.221c-.266-2.21-1.121-4.225-2.389-5.906l2.108-2.15c1.784 2.24 2.963 5.012 3.258 8.056h-2.978zM22.222 6.18C20.587 4.877 18.626 4 16.474 3.726V.666c2.963.304 5.66 1.515 7.842 3.348l-2.093 2.165zm-8.697-2.453c-2.152.273-4.113 1.151-5.734 2.453L5.684 4.014C7.866 2.18 10.564.97 13.526.667v3.059zm6.6 5.308L16.85 14.8l-.191.338.03.388c.083 1.055-.254 2.064-.954 2.777-1.332 1.373-3.522 1.373-4.848.005-1.344-1.377-1.344-3.628-.002-5.003.798-.821 1.937-1.16 3.066-.94l.453.089 5.723-3.42zM3.591 6.164l2.108 2.15C4.43 9.997 3.576 12.01 3.31 14.222H.333c.295-3.029 1.474-5.815 3.258-8.057z",
    transform: "translate(-29 -390) translate(29 390)"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcIndicatorsWhite);
export default __webpack_public_path__ + "static/media/ic_indicators_white.32c26076a1fb0de162443e3330eb935c.svg";
export { ForwardRef as ReactComponent };